import './autoLoginReporter';   // ← add this line (must be FIRST)
import React              from 'react';
import { BrowserRouter }  from 'react-router-dom';
import ReactDOM           from "react-dom/client";
import { Provider }       from 'react-redux';
import { configureStore } from './store/configureStore';
import App                from './App';
import reportWebVitals    from './reportWebVitals';


import './index.css';

export const store = configureStore();

const element = document.getElementById("root");

if (element !== null) {
   const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

   root.render(
      <React.StrictMode>
            <Provider store = { store }>
               <BrowserRouter>
                   <App/>
               </BrowserRouter>
            </Provider>
      </React.StrictMode>
   );
}




reportWebVitals();

